export default {
  volunteerWork: {
    volunteer_work_image: {
      type: 'single_node',
      tab: 'ROLE',
    },
    volunteer_work_role_title: {
      type: 'single_node',
      tab: 'ROLE',
    },
    volunteer_work_cause_title: {
      type: 'single_node',
      tab: 'CAUSE',
    },
    volunteer_work_role_description: {
      type: 'multiple_node',
      tab: 'DESCRIPTION',
    },
  },
  workExperience: {
    work_experience_image: {
      type: 'single_node',
      tab: 'JOB_DESCRIPTION',
    },
    work_experience_role_description: {
      type: 'single_node',
      tab: 'JOB_DESCRIPTION',
    },
    work_experience_role_achievements: {
      type: 'multiple_node',
      tab: 'JOB_ACHIEVEMENTS',
    },
  },
  education: {
    education_image: {
      type: 'single_node',
      tab: 'not_present',
    },
  },
  awardsAndHonors: {
    awards_and_honors_image: {
      type: 'single_node',
      tab: 'DESCRIPTION',
    },
  },
  publications: {
    publication: {
      type: 'single_node',
      tab: 'not_present',
    },
  },
  associations: {
    associations_image: {
      type: 'single_node',
      tab: 'DESCRIPTION',
    },
  },
  leadership: {
    leadership_image: {
      type: 'single_node',
      tab: 'DESCRIPTION',
    },
  },
  certifications: {
    certifications_image: {
      type: 'single_node',
      tab: 'not_present',
    },
  },
  conferences: {
    conferences_image: {
      type: 'single_node',
      tab: 'DESCRIPTION',
    },
  },
  patents: {
    patents_image: {
      type: 'single_node',
      tab: 'DESCRIPTION',
    },
  },
  courses: {
    courses_image: {
      type: 'single_node',
      tab: 'DESCRIPTION',
    },
  },
  languages: {
    language: {
      type: 'single_node',
      tab: 'not_present',
    },
  },
  references: {
    references_image: {
      type: 'single_node',
      tab: 'not_present',
    },
  },
  summary: {
    paragraph: {
      type: 'single_node',
      tab: 'not_present',
    },
  },
  testScores: {
    test_scores_image: {
      type: 'single_node',
      tab: 'not_present',
    },
  },
  skills: {
    skill_organization_name: {
      type: 'single_node',
      tab: 'not_present',
    },
  },
  hobbiesAndInterests: {
    hobbies_and_interests: {
      type: 'single_node',
      tab: 'not_present',
    },
  },
  projects: {
    projects_image: {
      type: 'single_node',
      tab: 'ASSOCIATED_URL',
    },
    projects_url_title: {
      type: 'single_node',
      tab: 'ASSOCIATED_URL',
    },
    projects_project_description: {
      type: 'single_node',
      tab: 'DESCRIPTION',
    },
  },
};
